"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[8371],{

/***/ 40536:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  X: () => (/* binding */ AbFtProvider),
  S: () => (/* binding */ useAbFt)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(11396);
// EXTERNAL MODULE: ./local_modules/cookie-storage/index.ts + 2 modules
var cookie_storage = __webpack_require__(9424);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(63687);
;// CONCATENATED MODULE: ./src/modules/user/abFt/modifyAbTests.ts
const modifyAbTests = (abTests, overrides)=>{
    if (!abTests) {
        return {};
    }
    return abTests.reduce((acc, param)=>{
        let { name, value, mixpanelProperty, enabled } = param;
        acc[name] = {
            value: (overrides === null || overrides === void 0 ? void 0 : overrides[name]) || value,
            mixpanelProperty,
            enabled
        };
        return acc;
    }, {});
};
/* harmony default export */ const abFt_modifyAbTests = (modifyAbTests);

;// CONCATENATED MODULE: ./src/modules/user/abFt/modifyFeatures.ts
const modifyFeatures = (features, overrides)=>{
    if (!features) {
        return {};
    }
    return features.reduce((acc, param)=>{
        let { name, enabled } = param;
        const queryValue = overrides === null || overrides === void 0 ? void 0 : overrides[name];
        if (typeof queryValue !== "undefined") {
            acc[name] = queryValue;
        } else {
            acc[name] = enabled;
        }
        return acc;
    }, {});
};
/* harmony default export */ const abFt_modifyFeatures = (modifyFeatures);

;// CONCATENATED MODULE: ./src/modules/user/abFt/graph/abFt.graphql.ts
const AbFtDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AbFt"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": {
                            "kind": "Name",
                            "value": "AbFt"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "AbFt"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Query"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "abTests"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "abTests"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "name"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "value"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "mixpanelProperty"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "enabled"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "features"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "featureToggles"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "name"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "enabled"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
AbFtDocument["definitions"] = [
    ...new Set(AbFtDocument.definitions)
];
/* harmony default export */ const abFt_graphql = (AbFtDocument);

;// CONCATENATED MODULE: ./src/modules/user/abFt/index.tsx








const defaultValue = {
    abTests: {},
    features: {}
};
const AbFtContext = /*#__PURE__*/ (0,react.createContext)(defaultValue);
const useAbFt = ()=>(0,react.useContext)(AbFtContext);
const AbFtProvider = (param)=>{
    let { children } = param;
    const { data } = (0,useQuery/* default */.Z)(abFt_graphql, {
        fetchPolicy: "cache-first"
    });
    const value = (0,react.useMemo)(()=>{
        var _data_abTests_data, _data_abTests, _data_features_data, _data_features;
        if (!data) {
            return defaultValue;
        }
        return {
            abTests: abFt_modifyAbTests((_data_abTests = data.abTests) === null || _data_abTests === void 0 ? void 0 : (_data_abTests_data = _data_abTests.data) === null || _data_abTests_data === void 0 ? void 0 : _data_abTests_data.abTests, cookie_storage/* default */.ZP.getItem(constants/* default */.Z.cookieNames.abTestsOverride)),
            features: abFt_modifyFeatures((_data_features = data.features) === null || _data_features === void 0 ? void 0 : (_data_features_data = _data_features.data) === null || _data_features_data === void 0 ? void 0 : _data_features_data.featureToggles, cookie_storage/* default */.ZP.getItem(constants/* default */.Z.cookieNames.featuresOverride))
        };
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AbFtContext.Provider, {
        value: value,
        children: children
    });
};


/***/ }),

/***/ 20575:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  c: () => (/* binding */ useEmailNotificationsUnsubscribe)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useMutation.ts + 1 modules
var useMutation = __webpack_require__(4578);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83305);
;// CONCATENATED MODULE: ./src/modules/user/emailNotifications/graph/userEmailUnsubscribe.graphql.ts
const UserEmailUnsubscribeDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UserEmailUnsubscribe"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "UserEmailInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "userEmailUnsubscribe"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ValidationError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "validationErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ServerError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "serverErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
UserEmailUnsubscribeDocument["definitions"] = [
    ...new Set(UserEmailUnsubscribeDocument.definitions)
];
/* harmony default export */ const userEmailUnsubscribe_graphql = (UserEmailUnsubscribeDocument);

;// CONCATENATED MODULE: ./src/modules/user/emailNotifications/index.ts




const useEmailNotificationsUnsubscribe = ()=>{
    const [mutate, { isFetching }] = (0,useMutation/* default */.Z)(userEmailUnsubscribe_graphql);
    const submit = (0,react.useCallback)(async (input)=>{
        const result = await mutate({
            variables: {
                input
            }
        });
        if (result.errors) {
            throw new errors/* GraphQLError */.__(result.errors);
        }
        const { error } = result.data.userEmailUnsubscribe;
        if (error) {
            throw new errors/* UserError */.gK(error);
        }
    }, [
        mutate
    ]);
    return [
        submit,
        {
            isFetching
        }
    ];
};


/***/ }),

/***/ 3268:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  a: () => (/* binding */ useLogout)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useApolloClients.tsx
var useApolloClients = __webpack_require__(60440);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(63687);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83305);
// EXTERNAL MODULE: ./local_modules/analytics/mixpanel/index.ts
var mixpanel = __webpack_require__(2303);
// EXTERNAL MODULE: ./local_modules/local-storage/index.ts + 2 modules
var local_storage = __webpack_require__(71106);
// EXTERNAL MODULE: ./local_modules/cookie-storage/index.ts + 2 modules
var cookie_storage = __webpack_require__(9424);
;// CONCATENATED MODULE: ./src/modules/user/logout/graph/userLogout.graphql.ts
const UserLogoutDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UserLogout"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "userLogout"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "SecurityError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
UserLogoutDocument["definitions"] = [
    ...new Set(UserLogoutDocument.definitions)
];
/* harmony default export */ const userLogout_graphql = (UserLogoutDocument);

;// CONCATENATED MODULE: ./src/modules/user/logout/index.ts







const cookiesToDelete = [
    constants/* default */.Z.cookieNames.discountCoupon,
    constants/* default */.Z.cookieNames.country,
    constants/* default */.Z.cookieNames.appliedCouponCode,
    constants/* default */.Z.cookieNames.isFreeTrialCoupon,
    constants/* default */.Z.cookieNames.resubscribeOffer,
    constants/* default */.Z.cookieNames.selectedPlan,
    constants/* default */.Z.cookieNames.isAddToQueueCaseUpsellModalShown,
    constants/* default */.Z.cookieNames.isAddToCartCaseUpsellModalShown,
    constants/* default */.Z.cookieNames.isHereticCaseUpsellModalShown,
    constants/* default */.Z.cookieNames.cardUpdateOffer
];
const localStorageToDelete = [
    constants/* default */.Z.localStorageNames.shippingFormValues,
    constants/* default */.Z.localStorageNames.authGender,
    constants/* default */.Z.localStorageNames.authEmail,
    constants/* default */.Z.localStorageNames.queuePendingProducts,
    constants/* default */.Z.localStorageNames.queueHighPriorityProducts,
    constants/* default */.Z.localStorageNames.queueLowPriorityProducts,
    constants/* default */.Z.localStorageNames.iterableOptInPendingProjects,
    constants/* default */.Z.localStorageNames.trackedExperiments
];
const useLogout = ()=>{
    const client = (0,useApolloClients/* useApolloClient */.x)();
    return (0,react.useCallback)(async function() {
        let { withLocalDataReset = true } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const result = await client.mutate({
            mutation: userLogout_graphql
        });
        if (result.errors) {
            throw new errors/* GraphQLError */.__(result.errors);
        }
        if (withLocalDataReset) {
            // ATTN we don't care about an error
            mixpanel/* default */.Z.reset();
            localStorageToDelete.forEach((name)=>local_storage/* default */.Z.removeItem(name));
            cookiesToDelete.forEach((name)=>cookie_storage/* default */.ZP.removeItem(name));
        }
    }, [
        client
    ]);
};


/***/ }),

/***/ 78159:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MW: () => (/* binding */ shownModalPrefix),
/* harmony export */   TJ: () => (/* binding */ useOptInEmailResolvePostponedProjects),
/* harmony export */   UT: () => (/* binding */ isOptInModalShouldBeShown),
/* harmony export */   zH: () => (/* binding */ useOptInEmail)
/* harmony export */ });
/* unused harmony export optInBrandsSlugs */
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63687);
/* harmony import */ var local_storage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71106);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53297);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40038);






const optInIterableProject = async (param)=>{
    let { projectName, email, firstName, lastName } = param;
    logger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.info({
        email,
        firstName,
        lastName
    }, `[Iterable] identify (${projectName})`);
    window.fetch("/iterable/update-user", {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            method: "identify",
            project: projectName,
            data: {
                email,
                dataFields: {
                    first_name: firstName,
                    last_name: lastName
                }
            }
        })
    }).catch((error)=>{
        logger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.warn(error, "Interable update user error");
    });
};
const addProjectToPostponed = (projectName)=>{
    const pendingProjects = local_storage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.getItem(helpers__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.localStorageNames.iterableOptInPendingProjects) || [];
    if (pendingProjects.includes(projectName)) {
        return;
    }
    pendingProjects.push(projectName);
    local_storage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.setItem(helpers__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.localStorageNames.iterableOptInPendingProjects, pendingProjects);
};
const shownModalPrefix = "opt-in-brand-";
const optInBrandsSlugs = [
    "sanctuary",
    "goodhabit",
    "deck-of-scarlet",
    "confessions-of-a-rebel"
];
const useOptInEmail = ()=>{
    const { isLoggedIn, user } = (0,modules_user__WEBPACK_IMPORTED_MODULE_5__/* .useUser */ .aF)();
    const optInEmail = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((projectName)=>{
        if (!isLoggedIn) {
            addProjectToPostponed(projectName);
            return;
        }
        void optInIterableProject({
            projectName,
            email: user.email,
            lastName: user.lastName,
            firstName: user.firstName
        });
    }, [
        isLoggedIn,
        user
    ]);
    return {
        optInEmail
    };
};
const useOptInEmailResolvePostponedProjects = ()=>{
    const { user } = (0,modules_user__WEBPACK_IMPORTED_MODULE_5__/* .useUser */ .aF)();
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        const pendingProjects = local_storage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.getItem(helpers__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.localStorageNames.iterableOptInPendingProjects);
        pendingProjects === null || pendingProjects === void 0 ? void 0 : pendingProjects.forEach((projectName)=>{
            void optInIterableProject({
                projectName,
                email: user.email,
                lastName: user.lastName,
                firstName: user.firstName
            });
        });
        local_storage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.removeItem(helpers__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.localStorageNames.iterableOptInPendingProjects);
    }, [
        user
    ]);
};
const isOptInModalShouldBeShown = (props)=>{
    var _shownPopups_popupName;
    const { brandSlug, shownPopups } = props;
    const popupName = shownModalPrefix + brandSlug;
    const isOptInPopup = optInBrandsSlugs.includes(brandSlug);
    const alreadyShown = Boolean((_shownPopups_popupName = shownPopups[popupName]) === null || _shownPopups_popupName === void 0 ? void 0 : _shownPopups_popupName.count);
    return isOptInPopup && !alreadyShown;
};


/***/ }),

/***/ 66349:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const ReferralInviteDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "ReferralInvite"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "ReferralInviteInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "referralInvite"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "success"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "email"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "SecurityError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "securityErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ReferralInviteError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "referralInviteErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
ReferralInviteDocument["definitions"] = [
    ...new Set(ReferralInviteDocument.definitions)
];
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ReferralInviteDocument);


/***/ }),

/***/ 21380:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W: () => (/* binding */ useSendInvite),
/* harmony export */   n: () => (/* binding */ useReferralInvites)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83305);
/* harmony import */ var apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4578);
/* harmony import */ var modules_user_user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40038);
/* harmony import */ var _graphql_referralInvite_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66349);





const useReferralInvites = ()=>{
    const { userInvites } = (0,modules_user_user__WEBPACK_IMPORTED_MODULE_1__/* .useUser */ .aF)();
    const stats = userInvites ? userInvites.statistics : {
        available: 0,
        sent: 0,
        redeemed: 0
    };
    return {
        stats
    };
};
const useSendInvite = ()=>{
    const [mutate, { isFetching }] = (0,apollo_client__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_graphql_referralInvite_graphql__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
    const sendInvite = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (input)=>{
        const result = await mutate({
            variables: {
                input
            },
            refetchQueries: [
                "User"
            ]
        });
        if (result.errors) {
            throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .GraphQLError */ .__(result.errors);
        }
        const { data, error } = result.data.referralInvite;
        if (error) {
            throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .UserError */ .gK(error);
        }
        return data;
    }, [
        mutate
    ]);
    return {
        sendInvite,
        isFetching
    };
};


/***/ }),

/***/ 59247:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  vB: () => (/* binding */ ShownPopupsProvider),
  aw: () => (/* binding */ useSetPopupShown),
  BP: () => (/* binding */ useShownPopups)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(11396);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useApolloClients.tsx
var useApolloClients = __webpack_require__(60440);
;// CONCATENATED MODULE: ./src/modules/user/shownPopups/graph/shownPopups.graphql.ts
const ShownPopupsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "ShownPopups"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currentUser"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "shownPopups"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "PopupShown"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "PopupShown"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "PopupShown"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "popupId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "count"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastUpdated"
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
ShownPopupsDocument["definitions"] = [
    ...new Set(ShownPopupsDocument.definitions)
];
/* harmony default export */ const shownPopups_graphql = (ShownPopupsDocument);

;// CONCATENATED MODULE: ./src/modules/user/shownPopups/graph/popupShown.graphql.ts
const PopupShownDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "PopupShown"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "PopupShownInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "popupShown"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "popup"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "PopupShown"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "SecurityError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "securityErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ServerError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "serverErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "PopupShown"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "PopupShown"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "popupId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "count"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastUpdated"
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
PopupShownDocument["definitions"] = [
    ...new Set(PopupShownDocument.definitions)
];
/* harmony default export */ const popupShown_graphql = (PopupShownDocument);

;// CONCATENATED MODULE: ./src/modules/user/shownPopups/index.tsx





const ShownPopupsContext = /*#__PURE__*/ (0,react.createContext)(null);
const ShownPopupsProvider = (param)=>{
    let { children } = param;
    const { data, isFetching } = (0,useQuery/* default */.Z)(shownPopups_graphql, {
        fetchPolicy: "cache-first"
    });
    const shownPopups = (0,react.useMemo)(()=>{
        var _data_currentUser_data, _data_currentUser;
        const closedPopupsList = (data === null || data === void 0 ? void 0 : (_data_currentUser = data.currentUser) === null || _data_currentUser === void 0 ? void 0 : (_data_currentUser_data = _data_currentUser.data) === null || _data_currentUser_data === void 0 ? void 0 : _data_currentUser_data.shownPopups) || [];
        return closedPopupsList.reduce((result, param)=>{
            let { popupId, ...rest } = param;
            result[popupId] = rest;
            return result;
        }, {});
    }, [
        data
    ]);
    const value = {
        shownPopups,
        isFetching
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShownPopupsContext.Provider, {
        value: value,
        children: children
    });
};
const useShownPopups = ()=>(0,react.useContext)(ShownPopupsContext);
const useSetPopupShown = ()=>{
    const client = (0,useApolloClients/* useApolloClient */.x)();
    return (0,react.useCallback)((popupId)=>client.mutate({
            mutation: popupShown_graphql,
            variables: {
                input: {
                    popupId
                }
            },
            update: (cache, mutationResult)=>{
                cache.modify({
                    id: "UserData:{}",
                    fields: {
                        shownPopups: (shownPopupsRef)=>{
                            const popupData = mutationResult.data.popupShown.data.popup;
                            if (popupData.count > 1) {
                                return shownPopupsRef.map((shownPopup)=>{
                                    if (shownPopup.popupId === popupId) {
                                        return popupData;
                                    }
                                    return shownPopup;
                                });
                            }
                            return shownPopupsRef.concat(popupData);
                        }
                    }
                });
            }
        }), [
        client
    ]);
};


/***/ }),

/***/ 40038:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  dr: () => (/* binding */ UserProvider),
  Hu: () => (/* binding */ useIsUserUpdating),
  aF: () => (/* binding */ useUser)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(11396);
// EXTERNAL MODULE: ./local_modules/local-storage/index.ts + 2 modules
var local_storage = __webpack_require__(71106);
// EXTERNAL MODULE: ./local_modules/cookie-storage/index.ts + 2 modules
var cookie_storage = __webpack_require__(9424);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(63687);
;// CONCATENATED MODULE: ./src/modules/user/user/graph/user.graphql.ts
const UserDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "User"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currentUser"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "User"
                                                }
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "ReferralInvites"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "SecurityError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "securityErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ServerError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "serverErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "AnalyticsMetadata"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AnalyticsMetadata"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "mixpanelClientId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "daysFromFirstSubscription"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "firstSubscriptionDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lifetimeStatus"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lifeTimeRevenue"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "hasScentProfile"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "productsInQueueQty"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscriptionStatus"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscriptionPlan"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isGiftSubscription"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Address"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Address"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "primary"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "firstName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "country"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "city"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "region"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "postalCode"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "street1"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "street2"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "phone"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "User"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "UserData"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "personalInfo"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "analyticsMetadata"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "AnalyticsMetadata"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "registrationDate"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "email"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gender"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "firstName"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "lastName"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "birthday"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "tokenApi"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "addressInfo"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "shipping"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "Address"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "billing"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "Address"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "status"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "dateTime"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "ReferralInvites"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "UserData"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "referralInvites"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "statistics"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "available"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "sent"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "redeemed"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
UserDocument["definitions"] = [
    ...new Set(UserDocument.definitions)
];
/* harmony default export */ const user_graphql = (UserDocument);

;// CONCATENATED MODULE: ./src/modules/user/user/index.tsx







const UserContext = /*#__PURE__*/ (0,react.createContext)(null);
const UserProvider = (param)=>{
    let { children } = param;
    var _data_currentUser_data, _data_currentUser, _data_currentUser_data1, _data_currentUser1, _user_addressInfo, _user_analyticsMetadata, _data_currentUser_data2, _data_currentUser2, _user_addressInfo_shipping, _user_addressInfo1;
    const { data, isFetching } = (0,useQuery/* default */.Z)(user_graphql, {
        fetchPolicy: "cache-first"
    });
    const user = data === null || data === void 0 ? void 0 : (_data_currentUser = data.currentUser) === null || _data_currentUser === void 0 ? void 0 : (_data_currentUser_data = _data_currentUser.data) === null || _data_currentUser_data === void 0 ? void 0 : _data_currentUser_data.personalInfo;
    const userInvites = data === null || data === void 0 ? void 0 : (_data_currentUser1 = data.currentUser) === null || _data_currentUser1 === void 0 ? void 0 : (_data_currentUser_data1 = _data_currentUser1.data) === null || _data_currentUser_data1 === void 0 ? void 0 : _data_currentUser_data1.referralInvites;
    const isLoggedIn = user !== null;
    const gender = user ? user.gender : "FEMALE";
    const hasBillingAddress = Boolean(user === null || user === void 0 ? void 0 : (_user_addressInfo = user.addressInfo) === null || _user_addressInfo === void 0 ? void 0 : _user_addressInfo.billing);
    const hasScentProfile = Boolean(user === null || user === void 0 ? void 0 : (_user_analyticsMetadata = user.analyticsMetadata) === null || _user_analyticsMetadata === void 0 ? void 0 : _user_analyticsMetadata.hasScentProfile);
    const dateTime = (data === null || data === void 0 ? void 0 : (_data_currentUser2 = data.currentUser) === null || _data_currentUser2 === void 0 ? void 0 : (_data_currentUser_data2 = _data_currentUser2.data) === null || _data_currentUser_data2 === void 0 ? void 0 : _data_currentUser_data2.dateTime) || undefined;
    const tokenApi = user === null || user === void 0 ? void 0 : user.tokenApi;
    // current shipping country used for cart and offers
    const cookieCountry = cookie_storage/* default */.ZP.getItem(constants/* default */.Z.cookieNames.country) // useful for SSR
    ;
    const localStorageAddress =  true ? local_storage/* default */.Z.getItem(constants/* default */.Z.localStorageNames.shippingFormValues) : 0;
    const country = (user === null || user === void 0 ? void 0 : (_user_addressInfo1 = user.addressInfo) === null || _user_addressInfo1 === void 0 ? void 0 : (_user_addressInfo_shipping = _user_addressInfo1.shipping) === null || _user_addressInfo_shipping === void 0 ? void 0 : _user_addressInfo_shipping.country) || (localStorageAddress === null || localStorageAddress === void 0 ? void 0 : localStorageAddress.country) || cookieCountry || "US";
    (0,react.useEffect)(()=>{
        // set token for WS connection
        if (tokenApi) {
            local_storage/* default */.Z.setSessionItem("tokenApi", tokenApi);
        } else {
            local_storage/* default */.Z.removeSessionItem("tokenApi");
        }
    }, [
        tokenApi
    ]);
    const value = {
        user,
        userInvites,
        dateTime,
        isLoggedIn,
        gender,
        country,
        hasBillingAddress,
        hasScentProfile,
        isFetching
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserContext.Provider, {
        value: value,
        children: children
    });
};
const useUser = ()=>(0,react.useContext)(UserContext);
const useIsUserUpdating = ()=>{
    const { isFetching } = (0,useQuery/* default */.Z)(user_graphql, {
        fetchPolicy: "cache-only",
        notifyOnNetworkStatusChange: true
    });
    return isFetching;
};


/***/ })

}]);